import React from 'react'
import PropTypes from 'prop-types'
import { Form } from 'react-bootstrap'
import { InputField } from '../form'
import { formatDate } from '../../utils/date'

const disabledOptionValue = ''

const SelectionField = ({
  options,
  isUseFormikSelectionField = true,
  optionplaceholder,
  isKeyValuePair,
  size = 'lg',
  hidePlaceholder = false,
  ...rest
}) => {
  const placeholderText = optionplaceholder ? optionplaceholder : 'Select One'
  return (
    <>
      {isUseFormikSelectionField ? (
        <InputField
          as='select'
          type='text'
          placeholder={hidePlaceholder ? undefined : placeholderText}
          size={size}
          defaultValue={rest?.defaultValue || disabledOptionValue}
          {...rest}>
          {!hidePlaceholder && (
            <option disabled value={disabledOptionValue}>
              {placeholderText}
            </option>
          )}
          <SelectionOptions
            options={options}
            isKeyValuePair={isKeyValuePair}
            {...rest}
          />
        </InputField>
      ) : (
        <Form.Control
          as='select'
          type='text'
          placeholder={hidePlaceholder ? undefined : placeholderText}
          size={size}
          {...rest}>
          {!hidePlaceholder && (
            <option disabled value={disabledOptionValue}>
              {placeholderText}
            </option>
          )}
          <SelectionOptions
            options={options}
            isKeyValuePair={isKeyValuePair}
            {...rest}
          />
        </Form.Control>
      )}
    </>
  )
}

const convertTextToCapitalize = (promo) => {
  const promoText = promo ? promo?.toUpperCase() : promo
  return promoText
}

export const SelectionOptions = ({
  options,
  isKeyValuePair = false,
  keyprop = 'key',
  valueprop = 'value',
  labelProp = 'key',
  customKeyprop,
  customValueprop,
  customLabelProp,
  getCustomKeyValuePropsAsOption = false,
  getKeyAsOption = false,
  getValueAsOption = false,
  promoOptions,
}) => {
  if (promoOptions) {
    return (
      <>
        {options.map((option, index) => (
          <option
            key={`${option}-${index}`}
            value={option.code}
            disabled={option?.isExpired}>
            {`${convertTextToCapitalize(option.code)}${
              option?.extraValue ? option?.extraValue : ''
            }${option?.discount ? ` | ${option?.discount} % Off` : ''}${
              option?.maxAmount ? ' | Max $' + option?.maxAmount + ' ' : ''
            }${
              option?.expTime
                ? ` | Expires on ${formatDate(option?.expTime)}`
                : ''
            }`}
          </option>
        ))}
      </>
    )
  }

  return (
    <React.Fragment>
      {options.map((option, index) => {
        const optionValue = isKeyValuePair
          ? [
              JSON.stringify({
                key: option[keyprop],
                value: option[valueprop],
              }),
            ]
          : getKeyAsOption
          ? option.key
          : getCustomKeyValuePropsAsOption
          ? option[customValueprop]
          : getValueAsOption
          ? option.value
          : option

        const optionText = isKeyValuePair
          ? option[labelProp]
          : getKeyAsOption
          ? option.value
          : getCustomKeyValuePropsAsOption
          ? option[customLabelProp]
          : getValueAsOption
          ? option.label
          : option

        return (
          <option
            key={
              isKeyValuePair
                ? `${option[keyprop]}`
                : getKeyAsOption
                ? option.key
                : getCustomKeyValuePropsAsOption
                ? option[customKeyprop]
                : getValueAsOption
                ? option.value
                : `${option}-${index}`
            }
            value={optionValue}
            disabled={option?.disabled}
            title={option?.disabledTitle || option.fullValue || optionText}>
            {optionText}
          </option>
        )
      })}
    </React.Fragment>
  )
}

SelectionField.propsTypes = {
  label: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  hidePlaceholder: PropTypes.bool,
}

export default SelectionField
